export const smallTokensThreshold = +(import.meta.env.VITE_SMALL_TOKEN_THRESHOLD ?? 25);

// Shown for an active account that simply holds no assets (not an error).
export const NO_ASSETS_LABEL = 'Assets are missing';

// Regex patterns for account type identification
export const reDLA = /(\s)DL(A|\sA\d+)(\s|$)/; // dla bots
export const reMM = /\sMM\d?(\s|$)/; // ping-pong bots
export const reARBITRAGE = /\sARBITRAGE\d?(\s|$)/;
export const reADAPTIVE = /\sADAPTIVE\d?(\s|$)/;
export const reICEBERG = /\sICEBERG\d?(\s|$)/;
export const reMENKAR = /\sMENKAR\d?(\s|$)/;
export const reLIQUIDITY = /\bLIQUIDITY\b/i;
export const reFEE = /\sFEE\d?(\s|$)/;
/**
 * USD-pegged stablecoins, upper-cased, priced at exactly $1 in balance totals.
 *
 * An explicit allow-list rather than a "contains USD" pattern: tickers such as USDUC are
 * free-floating tokens that merely contain "USD", and pinning them to $1 inflated their USD value
 * (SKY-4457). It must still cover every pegged token the old pattern matched, because `getPrice`
 * skips the quote-price conversion for an "other" stablecoin — a pegged token missing from here
 * gets multiplied by its pair's quote price instead. Bridged variants (`USDC.e`) are listed
 * explicitly; extend the list when a new stablecoin is onboarded.
 *
 * Deliberately left out: sUSD (Synthetix) has repeatedly traded well off its peg, and
 * yield-bearing tokens such as USDY accrue above $1 — both use their server price.
 *
 * The balances feed carries no peg flag to derive this from, so the list is client-side.
 */
export const USD_STABLE_TOKENS: ReadonlySet<string> = new Set([
  'USD',
  'USDT',
  'USDC',
  'BUSD',
  'FDUSD',
  'TUSD',
  'USDP',
  'PYUSD',
  'DAI',
  'USDE',
  'USDS',
  'USD1',
  'USDD',
  'GUSD',
  'USDG',
  'RLUSD',
  'LUSD',
  'CRVUSD',
  'USDC.E',
  'USDT.E',
]);

// Object literal for sorting types
// 0 - quote, 1 - base, 2 - other
// but for sorting we need base to be in the first place, so we assign base = 0
export const sortObjType: Record<string | number, number> = {
  0: 1,
  1: 0,
  2: 2,
  base: 0,
  quote: 1,
  other: 2,
};
